package com.fireavert.yardi.service_requests.data_models.requests.client_requests

import kotlinx.serialization.Serializable

@Serializable
data class YardiClientServiceRequestCreateEditRequest(
    val serviceRequestId: String? = "",
    val credentialsId: Int,
    val propertyId: String,
    val unitId: String?,
    val tenantId: String?,
    val vendorId: String?,
    val name: String?,
    val description: String?,
    val accessNotes: String?,
    val fullDescription: String?,
    // Added new parameters
    val origin: String? = null,
    val roomCode: String? = null,
    val priority: String? = null,
    val category: String? = null,
    val subCategory: String? = null,
    val hasPermissionToEnter: Boolean? = null,
    val problemDescriptionNotes: String? = null,
    val tenantCaused: Boolean? = null,
    val requestorName: String? = null,
    val requestorPhoneNumber: String? = null,
    val requestorEmail: String? = null
    // val dueDate: String? = null // Uncomment if needed
)